export enum LoginDialogCloseReason {
  AUTO_CLOSE,
  USER_CLOSE,
  PASSWORD_RECOVERY,
  SIGN_UP,
}
